import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Slider from 'react-slick/lib/slider';
import { toast } from 'react-toastify';
import '../../assets/css/testimonials.css'
// import image_testione_1 from '../../assets/images/face_seventh_1.png';
// import image_testione_2 from '../../assets/images/face_seventh_2.png';
// import image_testione_3 from '../../assets/images/face_seventh_3.png';
import { getAllTestimonialsApi } from '../../Redux/Auth/Auth_Action';

const Testimonials = () => {

    const [testimonail, setTestimonail] = useState({ testimonailData: [] });

    const dispatch = useDispatch();
    const getAllTestimonials = () => {
        dispatch(getAllTestimonialsApi())
            .then((res) => {
                // console.log("response from testimonail page", res);
                setTestimonail({ ...testimonail, testimonailData: res.data.response.data });
            })
            .catch((e) => {
                // console.log('error from testimonail page', e);
                toast.error("Network Error");
            })
    }

    useEffect(() => {
        getAllTestimonials();
    }, [])



    // let testimonial_content = [
    //     {
    //         img: image_testione_1,
    //         content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    //         person_name: "Warren Saunders",
    //         person_role: "Customer"
    //     },
    //     {
    //         img: image_testione_2,
    //         content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    //         person_name: "Warren Saunders",
    //         person_role: "Customer"
    //     },
    //     {
    //         img: image_testione_3,
    //         content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam. adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
    //         person_name: "Warren Saunders",
    //         person_role: "Customer"
    //     },
    // ]

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className='Slider_testimonials_custom_arrows_next'
                // style={{ ...style, display: "block", background: "red", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }


    function SamplePrevArrow(props) {
        const { style, onClick } = props;
        return (
            <div
                className="Slider_packages_custom_arrows_prev"
                // style={{ ...style, display: "block", background: "green", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }


    const settings = {
        customPaging: function (i) {
            return (
                <a>
                    <img src={testimonail?.testimonailData?.data?.[i]?.media_url} alt="testimonials profile" />
                    {/* {testimonial_content.map((item, index) => {
                        return (
                            <img src={testimonial_content[index]?.img} />
                        )
                    })} */}
                </a>
            );
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
    };

    // console.log(testimonail)

    return (
        <div className='testimonials'>
            <div className='row'>
                <div className="col-lg-12 text-center mt-5">
                    <p className="f-30 f-mon-reg text-white mb-0">
                        TESTIMONIALS
                    </p>
                    <p className="f-40 f-mon-bold text-white lh-01 mt-1 txt-captl">
                        What people are saying about Prediction Dog.
                    </p>
                    <div className="border-btm-pink-secondsec my-3">
                    </div>
                    <Slider {...settings}>
                        {testimonail?.testimonailData?.data?.map((item, index) => {
                            // console.log("testimaonailsss", item)
                            return (
                                <div key={index}>
                                    <div className='row'>
                                        <div className='col-lg-12 text-left'>
                                            <div className='content'>
                                                <p className='f-mon-semibold text-white f-82 transfrm-skew-testimon'>"</p>
                                                <div className='text-white f-mon-light f-20 margin-top-testimon text-center' dangerouslySetInnerHTML={{ __html: item?.comment }}></div>
                                                <p className='f-mon-semibold f-20 text-white text-center mb-0 text-center'>{item?.name}</p>
                                                <p className='f-13 f-mon-light clr-wht-50  text-center mrgn-btm-testi'>{item?.type}</p>
                                                <p className='f-mon-semibold text-white f-82 transfrm-skew-testimon-last '>"</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default Testimonials;